module.exports = __webpack_public_path__ + "static/media/Jessy-Moussallem-Directing.7960e22c.jpg";